import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from '../common';
import { IPerson } from '../models/i-person';
import { IPersonCard, IFileCard } from '../models/i-person-card';
import { ApiResponse, BaseResponse } from '../models/responses';

@Injectable({
  providedIn: 'root'
})
export class PersonService {

  constructor(private http: HttpClient) { }

  GetLastPeople(): Observable<ApiResponse<IPerson[]>> {
    return this.http.get<ApiResponse<IPerson[]>>(
      `${Constants.API_URL}api/Person/GetLastPeople`)
  }

  GetPeople(): Observable<ApiResponse<IPerson[]>> {
    return this.http.get<ApiResponse<IPerson[]>>(
      `${Constants.API_URL}api/Person/GetPeople`)
  }

  GetPersonCardsCount(Card, User, From, To, State, Active): Observable<ApiResponse<number>> {
    return this.http.get<ApiResponse<number>>(
      `${Constants.API_URL}api/PersonCard/GetPersonCardsCount?Card=${Card}&User=${User}&From=${From}&To=${To}&State=${State}&Active=${Active}`)
  }

  GetPersonCardsPaged(Card, User, From, To, State, Active, Offset, PageSize): Observable<ApiResponse<IPersonCard[]>> {
    return this.http.get<ApiResponse<IPersonCard[]>>(
      `${Constants.API_URL}api/PersonCard/GetPersonCardsPaged?Card=${Card}&User=${User}&From=${From}&To=${To}&State=${State}&Active=${Active}&Offset=${Offset}&PageSize=${PageSize}`)
  }

  GetPeopleCount(Card, Filter, From, To): Observable<ApiResponse<number>> {
    return this.http.get<ApiResponse<number>>(
      `${Constants.API_URL}api/Person/GetPeopleCount?Card=${Card}&Filter=${Filter}&From=${From}&To=${To}`)
  }

  GetPeoplePaged(Card, Filter, From, To, Offset, PageSize): Observable<ApiResponse<IPerson[]>> {
    return this.http.get<ApiResponse<IPerson[]>>(
      `${Constants.API_URL}api/Person/GetPeoplePaged?Card=${Card}&Filter=${Filter}&From=${From}&To=${To}&Offset=${Offset}&PageSize=${PageSize}`)
  }

  GetPersonCards(): Observable<ApiResponse<IPersonCard[]>> {
    return this.http.get<ApiResponse<IPersonCard[]>>(
      `${Constants.API_URL}api/PersonCard/GetPersonCards`)
  }

  GetPersonCardById(Id: number): Observable<ApiResponse<IPersonCard>> {
    return this.http.get<ApiResponse<IPersonCard>>(
      `${Constants.API_URL}api/PersonCard/GetPersonCardById?Id=${Id}`)
  }

  PostPersonCard(PersonCard: IPersonCard): Observable<BaseResponse> {
    return this.http.post<BaseResponse>(
      `${Constants.API_URL}api/PersonCard/PostPersonCard`, PersonCard)
  }

  PostFileCards(FileCards: IFileCard[]): Observable<ApiResponse<IFileCard[]>> {
    return this.http.post<ApiResponse<IFileCard[]>>(
      `${Constants.API_URL}api/PersonCard/PostFileCards`, FileCards)
  }
}
